import { useEventListener, useResizeObserver } from '@vueuse/core';
import { onMounted, ref } from 'vue';

/**
 * Reactive CSS `top` offset for a sticky element that needs to sit below the
 * app header (and the page header, when it's also sticky). Tracks both
 * elements via ResizeObserver so theme/layout-driven height changes propagate
 * without manual recomputation.
 */
export default function useStickyTop() {
    const top = ref('0px');
    const appHeaderEl = ref<HTMLElement | null>(null);
    const pageHeaderEl = ref<HTMLElement | null>(null);

    const update = () => {
        const appHeaderHeight = appHeaderEl.value?.offsetHeight ?? 0;
        const pageHeaderIsSticky = pageHeaderEl.value && window.getComputedStyle(pageHeaderEl.value).position === 'sticky';
        const pageHeaderHeight = pageHeaderIsSticky ? (pageHeaderEl.value?.offsetHeight ?? 0) : 0;
        const next = `${appHeaderHeight + pageHeaderHeight}px`;
        if (next !== top.value) {
            top.value = next;
        }
    };

    onMounted(() => {
        appHeaderEl.value = document.getElementById('app-header');
        pageHeaderEl.value = document.querySelector('.sticky-header');
        update();
    });

    useResizeObserver([appHeaderEl, pageHeaderEl], update);
    useEventListener(window, 'resize', update);

    return top;
}
